<!-- 客户详情 -->
<template>
    <div>
        <veui-drawer
            overlay-class="customer-detail"
            placement="right"
            title="新增潜客信息"
            :footless="true"
            :outside-closable="true"
            :open="open"
            :modal="true"
            @cancel="close"
        >
            <!-- 客户信息 -->
            <veui-form
                ref="form"
                class="info"
                :data="formData"
                :validators="validators"
            >
                <veui-field
                    name="name"
                    field="name"
                    label="客户姓名"
                    :rules="[{name: 'required', value: true, message: '请填写客户姓名'}]"
                >
                    <veui-input
                        v-model="formData.name"
                        maxlength="10"
                        placeholder="请输入客户姓名"
                    />
                </veui-field>
                <veui-field
                    label="客户身份"
                    name="userType"
                    :rules="[{name: 'required', triggers: 'change,blur', message: '请填写客户身份'}]"
                >
                    <veui-checkbox-group
                        v-model="formData.userType"
                        :items="identitys"
                    />
                </veui-field>
                <veui-field
                    name="license"
                    field="license"
                    label="执业资格证号"
                    class="license"
                    :rules="[
                        {name: 'required', triggers: 'input,blur'},
                        {
                            name: 'pattern',
                            value: /^(\d{17})$/,
                            message: '执业资格证号为17位组合数，请检查后提交',
                            triggers: 'input,blur',
                        }]"
                >
                    <veui-input
                        v-model="formData.license"
                        placeholder="请输入执业资格证号"
                    />
                    <div class="tip">请务必填写正确的执业资格证号，以免客保无效影响您正常售卖。</div>
                </veui-field>
                <veui-field
                    label="城市"
                    field="city"
                    name="city"
                    :rules="[{name: 'required', value: true, message: '请选择城市'}]"
                >
                    <citySelect
                        type="2"
                        extra-class="potential-customer-city"
                        @cityChange="cityChange"
                    />
                </veui-field>
                <veui-field
                    name="phone"
                    field="phone"
                    label="联系方式"
                >
                    <veui-input
                        v-model="formData.phone"
                        placeholder="请输入联系方式"
                    />
                </veui-field>
            </veui-form>
            <!-- 提交按钮 -->
            <div class="foot">
                <veui-button ui="primary" @click="handleSubmit">
                    提交
                </veui-button>
            </div>
        </veui-drawer>
    </div>
</template>

<script>
/**
 * @file index.vue
 * @desc 添加潜客
 * @author dingzhenyue
 */
import {Drawer, Button, Input, Field, Form, CheckboxGroup} from 'veui';
import {isBoolean} from 'lodash';
import citySelect from '@/components/citySelect.vue';

export default {
    name: 'customer-detail',
    props: {
        open: {
            'type': Boolean,
            'default': false
        },
        // 详情数据
        clientData: {
            'type': Object,
            'default': () => {}
        },
        // 机构id
        fid: {
            'type': String,
            'default': ''
        }
    },
    components: {
        'veui-drawer': Drawer,
        'veui-button': Button,
        'veui-input': Input,
        'veui-field': Field,
        'veui-form': Form,
        'veui-checkbox-group': CheckboxGroup,
        citySelect
    },
    watch: {
        clientData: {
            handler(val) {
                this.formData = {
                    ...this.formData,
                    ...val,
                    phone: ''
                };
            },
            immediate: true
        }
    },
    data() {
        return {
            formData: {
                name: '',
                license: '',
                phone: '',
                userType: [0]
            },
            regionOption: [], // 省市区
            // 身份
            identitys: [
                {
                    label: '律师',
                    value: 0,
                    exclusive: true
                }
            ],
            validators: [
                {
                    fields: ['phone'],
                    handler(phone) {
                        // 手机号可以为空
                        if (!phone) {
                            return true;
                        }
                        return new Promise(function (resolve) {
                            setTimeout(function () {
                                let res;
                                let reg = /^(1(3|4|5|6|7|8|9)\d{9})$/;
                                if (!reg.test(phone)) {
                                    res = {
                                        phone: '请填写正确的手机号或座机号'
                                    };
                                }
                                resolve(res);
                            });
                        });
                    },
                    triggers: ['submit']
                }
            ]
        };
    },
    mounted() {
        this.getCity();
    },
    methods: {

        /**
         * 关闭当前抽屉
         */

        close() {
            this.$emit('closeDrawer');
        },
        getCity() {
            // 20240607 迁移新城市接口 - sun
            this.$http.get('/bp/api/city/cityAll', {
                city_code: 0
            }).then(res => {
                res = this.$normalizeResponseData(res);
                if (res) {
                    this.regionOption = res;
                    if (this.clientData.city && this.formData.city?.length === 0) {
                        for (let i = 0; i < this.regionOption.length; i++) {
                            let cityInfo = this.regionOption[i].children;
                            if (!cityInfo) {
                                break;
                            }
                            for (let j = 0; j < cityInfo.length; j++) {
                                if (cityInfo[j].label.includes(this.clientData.city)) {
                                    this.formData.city = this.regionOption[i].value + '$' + cityInfo[j].value;
                                    this.formData.cityName = this.regionOption[i].label + '$' + cityInfo[j].label;
                                    return;
                                }
                            }
                        }
                    }
                }
            });
        },

        /**
         * 提交前的校验
         */

        handleSubmit() {
            this.$refs.form.validate().then(valid => {
                // 校验数据
                if (!isBoolean(valid)) {
                    this.$toast.error('有字段填写不符合标准，请重新填写');
                    return false;
                }
                this.submit();
            });
        },

        /**
         * 城市筛选改变时
         * @param {Object} data 选中数据
         */

        cityChange(data = {}) {
            let {selectedData, value} = data;
            this.formData.city = value?.join('$') || '';
            this.formData.cityName = selectedData ? selectedData[0].label + '$' + selectedData[1].label : '';
        },

        /**
         * 校验成功后的提交
         */

        submit() {
            if (this.isSubmit) {
                return;
            }
            this.isSubmit = true;
            let {license, city, name, phone, userType, cityName} = this.formData || {};
            this.$http.post('/bp/crm/addlawyer', {
                fid: this.fid,
                license,
                city,
                cityName,
                name,
                phone,
                userType: userType.length ? userType[0] : '',
                leads_id: this.clientData.id
            }).then(res => {
                if (!res || +res.code !== 0) {
                    this.$toast.error(res?.msg || '添加失败');
                    return;
                }
                this.$toast.success('添加成功');
                this.$emit('closeDrawer');
            }).finally(() => {
                this.isSubmit = false;
            });
        }
    }
};
</script>

<style lang='less' scoped>
.customer-detail {
    /deep/.veui-dialog-content-head {
        align-items: center;
        padding-bottom: 28px;

        .veui-dialog-content-head-title {
            font-family: PingFangSC-Medium;
            font-size: 18px;
            color: #000;
            line-height: 16px;
        }
    }

    /deep/.veui-dialog-content {
        width: 700px;
    }

    .veui-dialog-content-body {
        margin-top: 24px;
    }

    .info {
        /deep/.veui-input,
        /deep/.ivu-input {
            width: 500px;
        }

        /deep/.ivu-input {
            height: 32px;
            border: 1px solid #d3d9e6;

            &::-webkit-input-placeholder {
                color: rgba(80, 90, 107, .8);
            }
        }

        .license {
            /deep/.veui-field-messages {
                margin-top: 20px;
            }
        }

        .tip {
            position: absolute;
            bottom: -20px;
            font-size: 12px;
            color: rgba(80, 90, 107, .8);
        }
    }
}

.foot {
    position: absolute;
    bottom: 24px;
    right: 30px;
}

/deep/.veui-button.veui-dialog-content-head-close {
    color: #000;
}
</style>


